import React, { useState } from 'react';

// Logo del cliente en un círculo tipo foto de perfil de Instagram.
// Si la imagen tiene fondo propio, ocupa todo el círculo; si es transparente, va centrada sobre blanco.
export default function BrandAvatar({ src, name, size = 48 }) {
  const [mode, setMode] = useState('cover'); // 'cover' | 'contain'
  const [failed, setFailed] = useState(false);

  const detect = (e) => {
    const img = e.target;
    try {
      const w = 32, h = 32;
      const c = document.createElement('canvas'); c.width = w; c.height = h;
      const ctx = c.getContext('2d');
      ctx.drawImage(img, 0, 0, w, h);
      const px = (x, y) => ctx.getImageData(x, y, 1, 1).data[3];
      const corners = [px(0, 0), px(w - 1, 0), px(0, h - 1), px(w - 1, h - 1)];
      const transparent = corners.some(a => a < 200);
      const ratio = img.naturalWidth / img.naturalHeight;
      // transparente o muy apaisado/alto -> centrado sobre blanco sin recortar
      setMode(transparent || ratio > 1.3 || ratio < 0.77 ? 'contain' : 'cover');
    } catch { setMode('contain'); }
  };

  const initial = (name || '?').trim().charAt(0).toUpperCase();
  return (
    <div style={{ width: size, height: size, borderRadius: '50%', background: '#fff', overflow: 'hidden', flexShrink: 0,
      display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 0 0 2px var(--border)' }}>
      {src && !failed ? (
        <img src={src} alt={name || 'Logo'} onLoad={detect} onError={() => setFailed(true)}
          style={mode === 'cover'
            ? { width: '100%', height: '100%', objectFit: 'cover' }
            : { width: '72%', height: '72%', objectFit: 'contain' }} />
      ) : (
        <span style={{ fontWeight: 800, fontSize: size * 0.42, color: 'var(--accent)' }}>{initial}</span>
      )}
    </div>
  );
}
